// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useRef } from "react";
import { UPLOAD_TIMESHEET_TEXT } from "./constant";
import { FileUploadInput } from "./fileUploadInput";
import { Button } from "antd";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'title' implicitly has an 'any' type.
export function TimeSheetButton({ title, onFileChange, toggleShowImage, loading }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fileInput = useRef<any>(null);

  const handleClick = () => {
    if (title === UPLOAD_TIMESHEET_TEXT) {
      return fileInput.current?.click();
    }
    toggleShowImage();
  };

  return (
    <>
      <FileUploadInput onChange={onFileChange} inputRef={fileInput} />
      <Button
        loading={loading}
        /* @ts-expect-error FIXME this wrong type */
        type={title === UPLOAD_TIMESHEET_TEXT ? "danger" : "primary"}
        ghost
        onClick={handleClick}
        style={{
          margin: "10px",
          borderRadius: "2px",
        }}
      >
        {title}
      </Button>
    </>
  );
}
